var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGreenCheckDo = function SvgIconGreenCheckDo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#13AA6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.543 6.554 2.97 2.97-.743.742-2.97-2.97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.224 4.327.742.742-5.197 5.198-.742-.743z"
  })));
};
export { SvgIconGreenCheckDo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI3IiBmaWxsPSIjMTNBQTZEIi8+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMy41NDMgNi41NTRINy43NDNWNy42MDRIMy41NDN6IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAzLjU0MyA2LjU1NCkiLz4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xMC4yMjQgNC4zMjdIMTEuMjc0MDAwMDAwMDAwMDAxVjExLjY3N0gxMC4yMjR6IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMC4yMjQgNC4zMjcpIi8+Cjwvc3ZnPgo=";